import type { ReservationSlot } from '@jane/shared/types';

// Keep the selected time if the target mode has a matching slot, else its first.
export const resolveFulfillmentSlot = (
  currentSlotValue: string | undefined,
  targetSlots: ReservationSlot[]
): string => {
  const matchingSlot =
    currentSlotValue &&
    targetSlots.find(
      (slot) => slot.from === parseInt(currentSlotValue.split('>')[0])
    );

  if (matchingSlot) return `${matchingSlot.from}>${matchingSlot.to}`;

  return targetSlots.length
    ? `${targetSlots[0].from}>${targetSlots[0].to}`
    : '';
};
